import React from "react"
import { Box, Typography } from "@mui/material"
import DOMPurify from "dompurify";



export const ErrorBar = ({ error }) => {
    return (
        (error !== null && error !== "" &&
            <Box sx={{ ml: 3, mr: 9, my: 2, p: 0, border: "1px solid red" }}>
                <Typography
                    id="Error"
                    variant="body1"
                    gutterBottom={false}
                    align="left"
                    sx={{ pt: 1, pl: 3 }}
                    color="error"
                >
                    {/* {error} */}
                    <span
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(error) }}
                    />
                </Typography>

            </Box>
        )
    )
}